import { ADD_PRE_SIGNED_URL } from "../actions/types";

const initialState = {
  url: ""
};

export default function(state = initialState, action) {
  switch (action.type) {
    case ADD_PRE_SIGNED_URL:
      return {
        ...state,
        url: action.payload
      };
    default:
      return state;
  }
}
